import type { FC, ImgHTMLAttributes, ReactNode } from 'react';
import { useState } from 'react';

export interface PictureProps extends ImgHTMLAttributes<HTMLImageElement> {
  fallback?: ReactNode;
}

export const Picture: FC<PictureProps> = (props) => {
  // props
  const { children, fallback, ...attrs } = props;
  // state
  const [error, setError] = useState(false);

  if (typeof fallback !== 'undefined' && error) {
    return fallback;
  }

  return (
    <picture onError={() => setError(true)}>
      {children}
      <img loading="lazy" fetchPriority="low" {...attrs} />
    </picture>
  );
};
